/**
 * @module accountsEquity
 * @description A list of accountsEquity
 */
export const accountsEquity = [
	{
		objectNumber: 54001,
		name: "Director's Investment",
	},
	{
		objectNumber: 54003,
		name: 'Paid-in Capital',
	},
	{
		objectNumber: 54004,
		name: 'Retained Profits',
	},
	{
		objectNumber: 54002,
		name: 'Startup investment',
	},
	{
		objectNumber: 54005,
		name: 'Stock and Bonds',
	},
]
